<template>
  <a-select style="width: 100%" :placeholder="placeholder" @change="changeHandler" :value="value">
    <a-select-option v-for="option in options" :value="option.key">{{option.label}}</a-select-option>
  </a-select>
</template>

<script>
import { CRYSTAL_SYS } from '@/constants/cvts'

export default {
  props: {
    value: String,
    placeholder: {
      type: String,
      default: '请选择晶系'
    }
  },

  data () {
    return {
      options: CRYSTAL_SYS
    }
  },

  methods: {
    changeHandler (e) {
      this.$emit('input', e)
      this.$emit('change', e)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/CrystalSysSelector.vue